import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LazyLoadEvent } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs/operators';
import { AppComponentBase, PagedTableSummary } from 'src/app/app-component-base';
import {
    BusquedaIMSSResultDto
} from '../../../../shared/service-proxies/service-proxies';
import { DateTimeService } from '../../../../shared/services/datetime.service';


@Component({
    templateUrl: 'busquedapacientes-urgencias-grid.component.html',
    styleUrls: ['../../../../assets/css-custom/p-datatable-general.scss']
})
export class BusquedaPacientesUrgenciasGridComponent extends AppComponentBase implements OnInit {

    form: FormGroup;

    data: BusquedaIMSSResultDto[];
    pagedTableSummary: PagedTableSummary = new PagedTableSummary();

    cols: any[];
    selectedItem: any;

    blockedDocument = false;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private modalRef: DynamicDialogRef,
        private modalConfig: DynamicDialogConfig,
        private datetimeService: DateTimeService

    ) {
        super(injector);
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.form.controls;
    }

    get dtService() {
        return this.datetimeService;
    }

    ngOnInit() {
        const self = this;

        self.cols = [
            { field: 'tipoPaciente', header: this.l('Busquedas.Pacientes.IMSS.TipoPaciente'), width: '250px', isActive: true },
            { field: 'idee', header: this.l('Busquedas.Pacientes.IMSS.IDEE'), width: '250px', isActive: true },
            { field: 'curp', header: this.l('Busquedas.Pacientes.IMSS.CURP'), width: '250px', isActive: true },
            { field: 'nss', header: this.l('Busquedas.Pacientes.IMSS.NSS'), width: '250px', isActive: true },
            { field: 'agregadoMedico', header: this.l('Busquedas.Pacientes.IMSS.AgregadoMedico'), width: '250px', isActive: true },
            { field: 'nombre', header: this.l('Busquedas.Pacientes.IMSS.Nombre'), width: '250px', isActive: true },
            { field: 'apellidoPaterno', header: this.l('Busquedas.Pacientes.IMSS.ApellidoPaterno'), width: '250px', isActive: true },
            { field: 'apellidoMaterno', header: this.l('Busquedas.Pacientes.IMSS.ApellidoMaterno'), width: '250px', isActive: true },
            { field: 'sexo', header: this.l('Busquedas.Pacientes.IMSS.Sexo'), width: '250px', isActive: true },
            { field: 'fechaNacimiento', header: this.l('Busquedas.Pacientes.IMSS.FechaNacimiento'), width: '250px', isActive: true },
            { field: 'derechoIncapacidad', header: this.l('Busquedas.Pacientes.IMSS.DerechoIncapacidad'), isActive: true },
            { field: 'calle', header: this.l('Busquedas.Pacientes.IMSS.Direccion'), width: '250px', isActive: true },
            { field: 'colonia', header: this.l('Busquedas.Pacientes.IMSS.Colonia'), width: '250px', isActive: true },
            { field: 'numeroTelefonico', header: this.l('Busquedas.Pacientes.IMSS.Telefono'), width: '250px', isActive: true },
            {
                field: 'clavePresupuestal',
                header: this.l('Busquedas.Pacientes.IMSS.ClavePresupuestal'),
                width: '250px',
                isActive: true
            },
            {
                field: 'consultorioMedico',
                header: this.l('Busquedas.Pacientes.IMSS.ConsultorioMedico'),
                width: '250px',
                isActive: true
            },
            { field: 'turnoAtencion', header: this.l('Busquedas.Pacientes.IMSS.TurnoAtencion'), width: '250px', isActive: true },
            { field: 'registroPatronal', header: this.l('Busquedas.Pacientes.IMSS.RegistroPatronal'), width: '250px', isActive: true },
            { field: 'activo', header: this.l('Busquedas.Pacientes.IMSS.Situacion'), width: '250px', isActive: true },
            { field: 'fechaVigencia', header: this.l('Busquedas.Pacientes.IMSS.Vigencia'), width: '250px', isActive: true },
            { field: 'procedencia', header: this.l('Busquedas.Pacientes.IMSS.Procedencia'), width: '250px', isActive: true },
            { field: 'tipoConvenio', header: this.l('Busquedas.Pacientes.IMSS.TipoConvenio'), width: '250px', isActive: true },
            { field: 'tipoPension', header: this.l('Busquedas.Pacientes.IMSS.TipoPension'), width: '250px', isActive: true },
            { field: 'fechaDefuncion', header: this.l('Busquedas.Pacientes.IMSS.FechaDefuncion'), width: '250px', isActive: true },
            { field: 'observaciones', header: this.l('Busquedas.Pacientes.IMSS.Observaciones'), width: '250px', isActive: true },
        ];

        self.data = self.modalConfig.data.data;
    }

    esFecha(campo: string): boolean {
        const self = this;

        return campo === 'fechaNacimiento'
            || campo === 'fechaVigencia'
            || campo === 'fechaDefuncion';
    }

    esBool(campo: string): boolean {
        const self = this;

        return campo === 'derechoServicioMedico'
            || campo === 'derechoIncapacidad'
            || campo === 'autorizacionSesiones'
            || campo === 'activo';
    }

    return(paciente: BusquedaIMSSResultDto): void {
        const self = this;

        self.modalRef.close(paciente);
    }
}
